import React from 'react';
import PT from 'prop-types';
import Slider from 'react-slick';
import { Box, spacing } from '@procore/core-react';
import styled from 'styled-components';
import { Slide } from '@/react/styles/v2';
import { PlayButton } from '@/react/components';

const MAX_THUMBNAIL_SLIDES = 3.25;
const VideoThumbnail = styled(Box)`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  & > svg {
    display: block;
    position: absolute;
    top: 50%;
    left: calc(50% - ${spacing.sm}px);
    transform: translate(-50%, -50%);
    cursor: pointer;
  }
`;

const ThumbnailCarousel = ({
  screenshots,
  wistiaId,
  setThumbnailCarousel,
  mainCarousel,
}) => {
  const settings = {
    slidesToShow: MAX_THUMBNAIL_SLIDES,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: MAX_THUMBNAIL_SLIDES * 0.75 },
      },
    ],
  };

  return screenshots.length !== 0 ? (
    <Slider {...settings} asNavFor={mainCarousel} ref={setThumbnailCarousel}>
      {wistiaId && (
        <VideoThumbnail display="block" paddingRight="lg">
          <PlayButton />
          <Slide
            src={`https://fast.wistia.com/embed/medias/${wistiaId}/swatch`}
            data-testid={`video-thumbnail-slide-${wistiaId}`}
            style={{ maxHeight: '104px', height: '100%' }}
          />
        </VideoThumbnail>
      )}
      {screenshots?.map((slide, index) => (
        <Box key={slide.url} display="block" paddingRight="lg" margin="xs">
          <Slide
            src={slide.url}
            data-testid={`thumbnail-slide-${index}`}
            style={{ maxHeight: '104px', height: '100%' }}
          />
        </Box>
      ))}
    </Slider>
  ) : null;
};

ThumbnailCarousel.propTypes = {
  screenshots: PT.arrayOf(
    PT.shape({
      url: PT.string.isRequired,
    })
  ).isRequired,
  wistiaId: PT.string,
  setThumbnailCarousel: PT.func.isRequired,
  mainCarousel: PT.shape({}),
};

export default ThumbnailCarousel;
